import Api from "../api/api";

export default async (props) => {
  const response = await Api.post(
    `home-search-listings?page=${props.currentPage}`,
    props.body
  );
  return response.data.data;
};
